interface ConstructorParams {
	sellerId: number
	serviceId?: number | null
	feePercentage: number
}

export class SellerServiceAssociation {
	public sellerId: number
	public serviceId?: number | null
	public feePercentage: number

	constructor(params: ConstructorParams) {
		this.sellerId = params.sellerId
		this.serviceId = params.serviceId
		this.feePercentage = params.feePercentage
	}
}
